import { Card } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import moment from "moment";

import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

function wrapper(sidebarState, deviceStyle, miniNavbar, content) {
    if (sidebarState == 'exploring' && deviceStyle == 'mobile') {
        return (
            <SoftBox width='100%' height='100%'>
                {content}
            </SoftBox>
        )
    }
    else {
        return (
            <SoftBox mx={1} pb={2} sx={{ minWidth: { xxs: 'calc(100vw - 88px)', xs: 'calc(100vw - 182px)', sm: '400px'} }}>
                {content}
            </SoftBox>
        )
    }
}

function EventsBarPreviewCard({ event, sidebarState, deviceStyle, miniNavbar }) {

    const eventBoxShadowType = (boxShadows) => {
        if (event.type == 'active') {
            return boxShadows.activeEventBoxShadow;
        }
        else if (event.type == 'warning') {
            return boxShadows.warningEventBoxShadow;
        }

        return boxShadows.upcomingEventBoxShadow;
    };

    const navigate = useNavigate();

    const onEventClick = function () {
        // console.log(group)
        var group_ids = event.groups.map((row) => { return row.group_id });

        let path = '/explore/event-groups/' + group_ids.join(',');
        // console.log(navigate)
        navigate(path);
    }

    return (
        wrapper(sidebarState, deviceStyle, miniNavbar,
            (<Card onClick={() => onEventClick()} sx={({ boxShadows, breakpoints, functions: { pxToRem } }) => ({
                width: 'inherit',
                height: '100%',
                boxShadow: eventBoxShadowType(boxShadows)
            })}>
                <SoftBox py={2} px={1}
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        textAlign: 'center'
                    }}>
                    {event.type != 'active' ? (
                        <SoftBox py={1}>
                            <SoftTypography variant='h4' textTransform={'capitalize'} fontWeight={'medium'}>
                                {event.name}
                            </SoftTypography>
                            <SoftTypography variant='subtitle2' textTransform={'capitalize'}>
                                {event.type != 'warning' ? 'Upcoming' : event.type + ' Period'}
                            </SoftTypography>
                        </SoftBox>
                    ) : (
                        <SoftBox py={1}>
                            <SoftTypography variant='h3' textTransform={'capitalize'} fontWeight={'bold'}>
                                {event.name}
                            </SoftTypography>
                            <SoftTypography variant='subtitle2' textTransform={'capitalize'}>
                                Active Period
                            </SoftTypography>
                        </SoftBox>
                    )}
                    <SoftBox py={1}>
                        <SoftTypography variant={event.type != 'active' ? 'h6' : 'h5'}>
                            {event.description}
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>
            </Card>)
        )
    );
}

EventsBarPreviewCard.propTypes = {
    event: PropTypes.object,
    sidebarState: PropTypes.string,
    deviceStyle: PropTypes.string,
    miniNavbar: PropTypes.bool,
};


export default EventsBarPreviewCard;